<template>
  <section class="policy-info__detail">
    <h5 class="mb-1 fs-7 text-gray-700 mb-2">Общая информация</h5>
    <div class="podft-list p-4 rounded border mb-5">
      <div v-if="policy.global_id || policy.global" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Номер договора
          <span
            class="text-primary float-end cursor-pointer"
            role="button"
            tabindex="0"
            :title="'Скопировать: ' + contractNumber"
            @click="copyContractNumber"
            @keydown.enter.prevent="copyContractNumber"
          >{{ contractNumber }}</span>
        </div>
      </div>
      <div v-if="policy.id || policy.c_id" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Номер 1С
          <span class="text-gray-800 float-end" v-html="policy.id || policy.c_id"></span>
        </div>
      </div>
      <div v-if="policy.username" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Создал
          <span class="text-gray-800 float-end" v-html="policy.username"></span>
        </div>
      </div>
      <div v-if="policy.draft_ulid" class="podft-list__item">
        <div class="text-gray-600 fs-7"> ULID
          <span class="text-gray-800 float-end" v-html="policy.draft_ulid"></span>
        </div>
      </div>
      <div v-if="policy.product_type" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Продукт
          <span class="text-gray-800 float-end">{{policy.product_type}}</span>
        </div>
      </div>
      <div v-if="policy.product" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Продукт (код)
          <span class="text-gray-800 float-end">{{policy.product}}</span>
        </div>
      </div>
      <div v-if="policy.wk_number" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Номер чека
          <span class="text-gray-800 float-end" v-html="policy.wk_number"></span>
        </div>
      </div>
      <div v-if="policy.hasOwnProperty('payment_type') && policy.payment_type !== 3" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Способ оплаты
          <span class="text-gray-800 float-end"
                v-html="insurerIsPerson ? policy.payment_type === 0 ? 'Наличные' : 'Банковская карта' : 'Перечисление'"
          ></span>
        </div>
      </div>
      <div v-if="policy.premium" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Премия
          <span class="text-gray-800 float-end">{{ policy.premium.toLocaleString('ru-RU') }} тг.</span>
        </div>
      </div>
      <div v-if="policy.created_at || policy.date" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Создан
          <span class="text-gray-800 float-end" v-html="policy.created_at || policy.date"></span>
        </div>
      </div>
      <div v-if="policy.to || policy.from || policy.date_from || policy.date_to" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Срок действия
          <div class="float-end">
            <span class="badge badge-light-primary" v-html="policy.from || policy.date_from"></span>
            -
            <span class="badge badge-light-danger" v-html="policy.to || policy.date_to"></span>
          </div>
        </div>
      </div>
      <div v-if="policy.statusName" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Статус
          <span class="px-3 py-1 rounded text-white fs-9 fw-bold float-end" v-html="policy.statusName" :class="getStyle(policy.status)"></span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PolicyInfo',
  props: {
    policy: null
  },
  computed: {
    contractNumber() {
      return this.policy?.global_id || this.policy?.global || ''
    },
    insurerIsPerson() {
      const insurer = this.policy?.insurer
      if (!insurer) return true
      if (insurer.filter && typeof insurer.filter.person === 'boolean') return insurer.filter.person
      return insurer.person ?? true
    }
  },
  methods: {
    async copyContractNumber() {
      const text = String(this.contractNumber).trim()
      if (!text) return

      try {
        await navigator.clipboard.writeText(text)
        this.$notifySuccess({ message: 'Номер ' + text + ' скопирован' }, { duration: 500 })
      } catch {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'absolute'
        textarea.style.left = '-9999px'
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          this.$notifySuccess({ message: 'Номер ' + text + ' скопирован' }, { duration: 500 })
        } catch {
          this.$notifyError({ message: 'Не удалось скопировать номер ' + text }, { duration: 500 })
        } finally {
          document.body.removeChild(textarea)
        }
      }
    },
    getStyle(status) {
      if (status === 0) return 'bg-primary'
      if (status === 1) return 'bg-success'
      if (status === 2) return 'bg-danger'
      if (status >= 3) return 'bg-warning'
    }
  }
}
</script>

<style scoped>

</style>